import Vue from "vue";
import Router from "vue-router";
import Room from "./views/Room.vue";
import Login from "./views/Login.vue";
import Settings from "./views/Settings.vue";
import Sched from "./views/Sched.vue";
import Home from "./views/Home.vue";
import Arc from "./views/Arc.vue";
import ArcShare from "./views/ArcShare.vue";
import Bcast from "./views/Bcast.vue";
import Roomstats from "./views/Roomstats.vue";
import Share from "./views/Share.vue";
import Register from "./views/Register.vue";
import Preset from "./views/Preset.vue";
import Account from "./views/Account.vue";
import Download from "./views/Download.vue";
import ToApp from "./views/ToApp.vue";
import Quiz from "./views/Quiz.vue";
import Hall from "./views/Hall.vue";
import Truck from "./views/Truck.vue";
import SignOut from "./views/SignOut.vue";
import AdmUser from "./views/AdmUser.vue";
import AdmAcc from "./views/AdmAcc.vue";
import Chat from "./views/Chat.vue";
import Mirror from "./views/Mirror.vue";
import BAH from "./views/bah.vue";
import EventManager from "./views/EventManager.vue";
import EventList from "./views/EventList.vue";
import ManageEvent from "./views/ManageEvent.vue";
import UpdateEvent from "./views/UpdateEvent.vue";
import UpdateStages from "./views/UpdateStages.vue";
import UpdateSessions from "./views/UpdateSessions.vue";
import UpdateBooths from "./views/UpdateBooths.vue";
import UpdateNetworking from "./views/UpdateNetworking.vue";
import UpdateRegistration from "./views/UpdateRegistration.vue";
import UpdateSponsors from "./views/UpdateSponsors.vue";
import UpdateSalesRep from "./views/UpdateSalesRep.vue";
import Event from "./views/Event.vue";
import EventCal from "./views/EventCal.vue";
import Reception from "./views/Reception.vue";
import Sessions from "./views/Sessions.vue";
import Speakers from "./views/Speakers.vue";
import Sponsors from "./views/Sponsors.vue";
import Booths from "./views/Booths.vue";
import Networking from "./views/Networking.vue";
import EventSalesRep from "./views/EventSalesRep.vue";
import SysTest from "./views/SysTest.vue";
import Bounce from "./views/Bounce.vue";
import SlackInstall from "./views/SlackInstall.vue";
import Guest from "./views/Guest.vue";
import GuestOk from "./views/GuestOk.vue";
import StatViewer from "./views/StatViewer.vue";
import SurveyAcc from "./views/SurveyAcc.vue";
import UpdateTickets from "./views/UpdateTickets.vue"
import Tiny from "./views/Tiny.vue";

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  // base: window.location.pathName,
  routes: [
    { path: "/", redirect: "home" },
    { path: "/loggedinfrom/:usite", redirect: "home" },
    {
      path: "/login/:provider?",
      name: "login",
      component: Login,
      meta: {
        viewTitle: "Login",
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: false,
            redirect: "home"
          }
        ]
      }
    },
    {
      path: "/bounce/:cfg",
      name: "bounce",
      component: Bounce,
      meta: {
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: true,
          }
        ]
      }
    },
    {
      path: "/guest",
      name: "guest",
      component: Guest,
      meta: {
        permissions: [
          {
            role: "guest",
            access: true
          },
        ]
      }
    },
    {
      path: "/slackinstall/:cfg?",
      name: "slackinstall",
      component: SlackInstall,
      meta: {
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: true,
          }
        ]
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        viewTitle: "Register",
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: false,
            redirect: "home"
          }
        ]
      }
    },
    {
      path: "/preset",
      name: "preset",
      component: Preset,
      meta: {
        viewTitle: "Password Reset",
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: false,
            redirect: "home"
          }
        ]
      }
    },
    {
      path: "/download",
      name: "download",
      component: Download,
      meta: {
        viewTitle: "Download",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/bah",
      name: "hosting",
      component: BAH,
      meta: {
        viewTitle: "Become a Host",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/eventmanager/:acc",
      name: "eventmanager",
      component: EventManager,
      meta: {
        viewTitle: "EventManager",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/eventlist/:acc",
      name: "eventlist",
      component: EventList,
      meta: {
        viewTitle: "EventList",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/manage_event/:acc/:id",
      component: ManageEvent,
      children: [
	{ path: '', component:UpdateEvent, name:"manage_event",
          meta: {
            permissions: [{
              role: "guest",
              access: false,
              redirect: "login"
            },
          ]}
        },
	{ path: 'stages', component:UpdateStages, name:"update_stages" },
	{ path: 'sessions', component:UpdateSessions, name:"update_sessions" },
	{ path: 'booths', component:UpdateBooths, name:"update_booths" },
	{ path: 'networking', component:UpdateNetworking, name:"update_networking" },
	{ path: 'registration', component:UpdateRegistration, name:"update_registration" },
	{ path: 'sponsors', component:UpdateSponsors, name:"update_sponsors" },
	{ path: 'salesrep', component:UpdateSalesRep, name:"update_srep" },
  { path: 'tickets', component:UpdateTickets, name:"ticket_details"},
      ],
    },
    {
      path: "/event/:acc/:id",
      component: Event,
      children: [
	{ path: '', component:Reception, name:"event" },
	{ path: 'sessions', component:Sessions, name:"sessions" },
	{ path: 'speakers', component:Speakers, name:"speakers" },
	{ path: 'booths', component:Booths, name:"booths" },
	{ path: 'networking', component:Networking, name:"networking" },
	{ path: 'sponsors', component:Sponsors, name:"sponsors" },
	{ path: 'cal', component:EventCal, name:"cal" },
	{ path: 'salesrep', component:EventSalesRep, name:"salesrep" },
  { path: 'tickets', component:UpdateTickets, name:"tickets"},

	],
      meta: {
        viewTitle: "Event",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
          {
            role: "authenticatedUser",
            access: true,
          }
        ]
      }
    },
    {
      path: "/toapp",
      name: "toapp",
      component: ToApp,
      meta: {
        viewTitle: "ToApp",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/mirror",
      name: "mirror",
      component: Mirror,
      meta: {
        viewTitle: "Mirror",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/settings",
      name: "settings",
      component: Settings,
      meta: {
        viewTitle: "Settings",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/sched",
      name: "schedule",
      component: Sched,
      meta: {
        viewTitle: "Schedule",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/account",
      name: "account",
      component: Account,
      meta: {
        viewTitle: "Your Account",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/systest",
      name: "systest",
      component: SysTest,
      meta: {
        viewTitle: "System Test",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/stats",
      name: "stats",
      component: Roomstats,
      meta: {
        viewTitle: "Room Stats",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/share/:userid",
      name: "share",
      component: Share,
      meta: {
        viewTitle: "Share",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/camonly",
      name: "room-camonly",
      component: Room,
      props: true,
      meta: {
        viewTitle: "Room",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
    {
      path: "/:target/:acc/:uid/guest",
      name: "guestok",
      component: GuestOk,
      props: true,
      meta: {
        viewTitle: "GuestOk",
        permissions: [
          {
            role: "guest",
            access: true
          },
          {
            role: "authenticatedUser",
            access: true,
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid",
      name: "room",
      component: Room,
      props: true,
      meta: {
        viewTitle: "Room",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
    {
      path: "/chat/:acc/:uid",
      name: "chat",
      component: Chat,
      props: true,
      meta: {
        viewTitle: "Chat",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
    {
      path: "/chat",
      name: "mychat",
      component: Chat,
      props: true,
      meta: {
        viewTitle: "Chat",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        viewTitle: "Home",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
    {
      path: "/room/:acc/:uid/arcss/:handle/:userid",
      name: "archss",
      component: ArcShare,
      meta: {
        viewTitle: "ArcShare",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/arc/:handle?",
      name: "arc",
      component: Arc,
      meta: {
        viewTitle: "Arc",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/cast",
      name: "cast",
      component: Bcast,
      meta: {
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/quiz",
      name: "quiz",
      component: Quiz,
      meta: {
        viewTitle: "Quiz",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/hall",
      name: "hall",
      component: Hall,
      meta: {
        viewTitle: "Hall",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/truck",
      name: "truck",
      component: Truck,
      meta: {
        viewTitle: "Truck",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/room/:acc/:uid/t/:key",
      name: "tiny",
      component: Tiny,
      meta: {
        viewTitle: "Tint",
        permissions: [
          {
            role: "guest",
            access: true,
          },
	  {
            role: "authenticatedUser",
            access: true,
          },
        ]
      }
    },
    {
      path: "/signout",
      name: "signout",
      component: SignOut,
      meta: {
        viewTitle: "Sign Out",
        permissions: [
          {
            role: "authenticatedUser",
            access: true,
          },
          {
            role: "guest",
            access: true,
          }
        ]
      }
    },
    {
      path: "/adm/users",
      name: "admuser",
      component: AdmUser,
      meta: {
        viewTitle: "Admin Users",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/adm/acc",
      name: "admacc",
      component: AdmAcc,
      meta: {
        viewTitle: "Admin Account",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          }
        ]
      }
    },
    {
      path: "/stats",
      name: "stat-viewer",
      component: StatViewer,
      props: true,
      meta: {
        viewTitle: "Stats",
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
      {
      path: "/roomuse",
      name: "survey-acc",
      component: SurveyAcc,
      props: true,
      meta: {
        permissions: [
          {
            role: "guest",
            access: false,
            redirect: "login"
          },
        ]
      }
    },
  ]
});

export default router;

router.beforeEach((to, from, next) => {
  if (window.vx && window.vx.debug) { console.log("router from:"+JSON.stringify(from.path)+"to:"+JSON.stringify(to.path)); }
  if (from && from.path && from.path != "/") {
    /* Needs to be stashed in a cookie so that it is preserved across reloads */
    // eslint-disable-next-line
    router.vxhist = router.vxhist || {};
    if (from.name == "room") {
      router.vxhist.room = from.path;
    }
    if (from.name == "event") {
      router.vxhist.event = from.path;
    }
    if (from.name == "cast") {
      router.from_bcast = true;
    } else if (from.name != "login" &&
               from.name != "download" &&
               from.name != "account") {
      router.from_bcast = false;
    }
  }
  if (window.vx && window.vx.disable_routing) {
    if (window.vx.debug) { console.log("disable routing from"+from.path+" to "+to.path); }
    next(false);
  } else if (window.present_download(to.path)) {
    next();
  } else {
    next({path:'/download'});
  }
});
